import { sortBy } from 'lodash-es';
import { pathgen } from 'object-path-generator';
export var EnhancedAutocompleteOptionType = /*#__PURE__*/ function(EnhancedAutocompleteOptionType) {
    EnhancedAutocompleteOptionType["Item"] = "item";
    EnhancedAutocompleteOptionType["EmptySearch"] = "empty-search";
    EnhancedAutocompleteOptionType["IncompleteSearch"] = "incomplete-search";
    EnhancedAutocompleteOptionType["SectionHeader"] = "section-header";
    return EnhancedAutocompleteOptionType;
}({});
export const EnhancedAutocompleteTestIds = pathgen('EnhancedAutocompleteTestIds');
export const mapDataToOption = (data, keyField, labelField, getSectionLabel)=>({
        value: data[keyField],
        label: data[labelField],
        data,
        type: "item",
        sectionLabel: getSectionLabel === null || getSectionLabel === void 0 ? void 0 : getSectionLabel(data)
    });
const sectionRank = (sectionLabel, sectionOrder)=>{
    var _ref;
    if (sectionLabel == null || sectionOrder == null) return (_ref = sectionOrder === null || sectionOrder === void 0 ? void 0 : sectionOrder.length) !== null && _ref !== void 0 ? _ref : 0;
    const index = sectionOrder.indexOf(sectionLabel);
    return index === -1 ? sectionOrder.length : index;
};
const withSectionHeaders = (sortedOptions)=>{
    const result = [];
    let previousSection;
    sortedOptions.forEach((option)=>{
        if (option.sectionLabel != null && option.sectionLabel !== previousSection) {
            result.push({
                value: "section-header-".concat(option.sectionLabel),
                label: option.sectionLabel,
                type: "section-header",
                sectionLabel: option.sectionLabel
            });
            previousSection = option.sectionLabel;
        }
        result.push(option);
    });
    return result;
};
export const getOptions = (options, keyField, labelField, getSectionLabel, sectionOrder)=>{
    const mappedOptions = options.map((item)=>mapDataToOption(item, keyField, labelField, getSectionLabel));
    if (!getSectionLabel) {
        return sortBy(mappedOptions, (option)=>option.label.toLowerCase());
    }
    const sortedOptions = sortBy(mappedOptions, [
        (option)=>sectionRank(option.sectionLabel, sectionOrder),
        (option)=>{
            var _option_sectionLabel;
            return ((_option_sectionLabel = option.sectionLabel) !== null && _option_sectionLabel !== void 0 ? _option_sectionLabel : '').toLowerCase();
        },
        (option)=>option.label.toLowerCase()
    ]);
    return withSectionHeaders(sortedOptions);
};
const dropOrphanSectionHeaders = (options)=>options.filter((option, index)=>{
        if (option.type !== "section-header") return true;
        const next = options[index + 1];
        return next != null && next.type !== "section-header";
    });
export const findExactMatchOption = (options, searchText)=>{
    const normalized = searchText.trim().toLowerCase();
    if (!normalized) return undefined;
    return options.find((option)=>option.label.toLowerCase() === normalized);
};
export const filterEnhancedOptions = (options, searchText, getFilterText)=>{
    const normalized = searchText.toLowerCase();
    const matchedItems = options.filter((option)=>{
        if (option.type === "section-header") return true;
        const haystack = option.data && getFilterText ? getFilterText(option.data) : option.label;
        return haystack.toLowerCase().includes(normalized);
    });
    return dropOrphanSectionHeaders(matchedItems);
};
